import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoader from '../../../../../../components/PageLoader';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectMembershipsListItems } from '../../../../../../redux/memberships/selector';
import { memberships } from '../../../../../../redux/memberships/action';
import MembershipTypeComponent from '../components/membership-type.component';
import { membershipTypes } from '../../../../../../redux/membership-types/action';
import storePersist from '../../../../../../redux/storePersist';
import { selectMembershipTypesQueryItems } from '../../../../../../redux/membership-types/selector';


const ManagementMembershipType = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryData = useSelector(selectMembershipTypesQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const membershipItems = useSelector(selectMembershipsListItems)
const [
    selectedMembershipType,
    setSelectedMembershipType
  ] = useState<any>([])
  const libraryItems = storePersist?.get("library")?.current;
  const fetchMembershipTypeById= ()=>{
    dispatch(membershipTypes.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types/query`,entity:'membershipTypes',jsonData:{
          
    Records: [
      { 
              "Id": parmas?.id
          
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
 
})
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedMembershipType({ ...selectedMembershipType, [field]: event });
  }

  useEffect(
    () => {
        dispatch(memberships.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships/list`,
            entity: 'memberships',
            jsonData: { }
        }))
    .then(()=>{
      if (parmas?.id > 0) {
        fetchMembershipTypeById()
        setIsLoading(false)
      }else {
        setIsLoading(false)
      }
     
    })
    
     
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedMembershipType(queryData?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    
    if (parmas?.id > 0) {
    
     dispatch(membershipTypes.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types`,entity:'membershipTypes',jsonData:{
          
    Records: [
        selectedMembershipType
    ]
 
}})).then(()=>{
  back()
})

    }else{
      dispatch(membershipTypes.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types`,entity:'membershipTypes',jsonData:{
          
      Records: [    
        selectedMembershipType
      ]
    
  }})).then(()=>{
    back()
  })
    }
   
   
  }

const back=()=>{
  navigate('/management/organization/membership-management/membership-types')
} 




    return (
    <>

    {isLoading ? <PageLoader /> : 
         <MembershipTypeComponent 
         membership={membershipItems?.result?.items}
         types={libraryItems.MembershipTypes}
         handleInnerFormChange={handleInnerFormChange}
         selectedMembershipType={selectedMembershipType}
         back={back}
         handleFormSubmit={handleFormSubmit}
         />  
    }
    
          </>
    )
    
    }
   
    export default ManagementMembershipType;